export const UpgradePlanText = "Upgrade your plan to use this feature";
